import stepview from './stepview/stepview.vue'

const comment = {
    install: function(Vue) {
      Vue.component(stepview.name, stepview)
    }
  }
  // global 情况下 自动安装
  if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.use(comment)
  }
  // 导出模块
  export default comment


// WEBPACK FOOTER //
// ./src/base/index.js